import { createContext, useContext } from 'react';

import type { AssignWizardContextValue } from 'pages/custom_tests_v1/components/assign_wizard/AssignWizard';

export const AssignWizardContext = createContext({} as AssignWizardContextValue);
AssignWizardContext.displayName = 'AssignWizardContext';

export const useAssignWizard = () => useContext(AssignWizardContext);